import {
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { asReffable, snapshot } from '@principle-theorem/shared';
import { from } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Brand } from '../../brand';
import { Organisation } from '../../organisation/organisation';
import { Practice } from '../practice';
import { IPracticeSetupStepDefinition } from './practice-setup-step.types';
import { initRawSchema } from '@principle-theorem/editor';

export const staffSetupStep: IPracticeSetupStepDefinition = {
  id: PracticeSetupStepId.StaffSetup,
  category: PracticeSetupStepCategory.GeneralPracticeSettings,
  title: 'Invite and Configure Users',
  description: initRawSchema(
    `Invite staff members and ensure relevant roles and access permissions have been applied. Each member of your team will access Principle using their unique login. This page will allow you to invite, disable, and modify user accounts, as well as assign roles to each user. After inviting each user, be sure to assign both a Role and Access privileges to them.`
  ),
  dependsOn: [PracticeSetupStepId.RoleSettings],
  getRoute: (_brand, _practice) => `settings/workspace/users`,
  validate$: (practice$, _step, _options) => {
    return practice$.pipe(
      switchMap((practice) => {
        const brandRef = Practice.brandRef(practice);
        const organisationRef = Brand.organisationRef(asReffable(brandRef));

        return from(
          snapshot(Organisation.users$(asReffable(organisationRef), true))
        ).pipe(
          map((users) => {
            if (users.length <= 1) {
              return {
                valid: false,
                reason: 'No staff have been added yet',
              };
            }

            return { valid: true };
          })
        );
      })
    );
  },
  pageVisitTracking: {
    routes: ['settings/workspace/users'],
    validationMode: 'any',
  },
};
